import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

/**
 * Shared access gate used across app pages (signed-out or restricted account).
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.description
 * @param {string} [props.className]
 * @param {"signed-out"|"restricted"} [props.variant]
 * @returns {JSX.Element}
 */
export default function SignedOutPrompt({
  title,
  description,
  className,
  variant = "signed-out",
}) {
  const isRestricted = variant === "restricted";

  return (
    <div className={className ?? "mx-auto max-w-lg px-4 py-10"}>
      <Card>
        <CardHeader>
          <CardTitle className="font-display text-2xl font-medium">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          {isRestricted ? (
            <Button asChild>
              <Link to="/explore">Open Explore</Link>
            </Button>
          ) : (
            <>
              <Button asChild>
                <Link to="/login">Sign in</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/create-account">Create account</Link>
              </Button>
              <p className="text-center text-sm text-text-muted">
                Organizations and individual ministry leaders can apply here. Invited staff can use the
                link in their email.
              </p>
              <p className="pt-1 text-center text-sm text-text-muted">
                Want to browse first?{" "}
                <Link to="/explore" className="font-semibold text-accent hover:underline">
                  Open Explore
                </Link>
              </p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
